import { defineStore } from "pinia";
import axios from "axios";
import { getCurrentInstance } from "vue";



export const useAppStore = defineStore("auth", {
  state: () => ({
    baseUrl: import.meta.env.VITE_API_BASE_URL || "",

    accessToken: sessionStorage.getItem("access_token") || null,
    refreshToken: sessionStorage.getItem("refresh_token") || null,
    // expiresAt: sessionStorage.getItem("expires_at") || null,
    user: JSON.parse(sessionStorage.getItem("user") || "null"),
    loadingAuth: false,
    authError: null,

    //Stati usati per le chiamate API
    apiState: "init", // init, loading, loaded, error
    apiResult: {},

    //Eventuale titolo della pagina
    title: null,

    sections: [], //sezioni visibili per l'utente

    oauth: {
      //configurazione di autenticazione (iniettata da main.js)
      vuoto: true,
    },
  }),

  getters: {
    apiBaseUrl: function (state) {
      return state.baseUrl + "/api/v1";
    },

    async fetchServerConfig() {
      this.loadingAuth = true;
      this.authError = null;

      try {
        const response = await fetch(`${this.apiBaseUrl}/config`, {
          credentials: "include",
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const config = await response.json();
        this.serverConfig = config;

        // Aggiorna i dati utente se restituiti
        if (config.user) {
          this.user = config.user;
          sessionStorage.setItem("user", JSON.stringify(config.user));
        }

        console.log("Server config loaded:", config);
        return config;
      } catch (error) {
        console.error("Error fetching server config:", error);
        this.authError = error.message;

        // Fallback per sviluppo locale
        this.serverConfig = {
          auth: {
            oauth2: {},
          },
          server: {
            name: "AEGENT (fallback)",
            version: "1.0.0",
            environment: "development",
          },
        };
        throw error;
      } finally {
        this.loadingAuth = false;
      }
    },

    isAuthenticated(state) {
      if (state.user && (state.user.uid > 0 || state.user?.superuser.sid > 0)) {
        return true;
      }
      return false;
    },

    isAdmin(state) {
      let roles = state.user?.roles || [];
      return roles.includes("admin");
    },



    getUserName(state) {
      let name = "";
      if (state.user?.superuser) {
        name = state.user.superuser.realname || "";
        let surname = state.user.superuser.realsurname || "";
        name = name + " " + surname;
      }

      if (state.user?.profiles && state.user.profiles.length > 1) {
        name = name + " (" + state.user.name + ")";
      }

      return name;
    },
  },

  actions: {
    login() {
      //la redirectURI la generiamo dal serevr

      let self = this;

      let oauth = this.serverConfig.auth.oauth2;

      // {
      //               'client_id': os.getenv('KEYCLOAK_CLIENT_ID'),
      //               'auth_url': f"{os.getenv('KEYCLOAK_URL')}/realms/{os.getenv('KEYCLOAK_REALM')}/protocol/openid-connect/auth",
      //               'token_url': f"{os.getenv('KEYCLOAK_URL')}/realms/{os.getenv('KEYCLOAK_REALM')}/protocol/openid-connect/token",
      //               'userinfo_url': f"{os.getenv('KEYCLOAK_URL')}/realms/{os.getenv('KEYCLOAK_REALM')}/protocol/openid-connect/userinfo",
      //               'logout_url': f"{os.getenv('KEYCLOAK_URL')}/realms/{os.getenv('KEYCLOAK_REALM')}/protocol/openid-connect/logout",
      //               'scopes': ['openid', 'profile', 'email'],
      //               'response_type': 'code',
      //               'redirect_uri': f"http://localhost:{os.getenv('FRONTEND_PORT', '8888')}/auth/callback"
      //           }

      var redirect_uri = oauth.redirect_uri;
      var scope = "";
      if (oauth.scopes) {
        scope = "&scope=" + oauth.scopes.join(" ");
      }
      let url = "";
      if (oauth.authorization_endpoint) {
        url = oauth.authorization_endpoint;
      } else {
        url = oauth["auth_url"];
      }
      let oauth2_authorize =
        url +
        "?response_type=code" +
        scope +
        "&redirect_uri=" +
        redirect_uri +
        "&client_id=" +
        oauth.client_id;
      try {
        const redirectUrl = window.location.href;
        localStorage.setItem("post_login_redirect", redirectUrl);
      } catch (e) {
        console.error(
          "Error saving post login redirect URL to localStorage:",
          e
        );
      }
      window.location = oauth2_authorize;
    },

    hasRole(role) {
      let roles = this.user?.roles || [];
      return roles.includes(role);
    },

    //solve the code oauth2 and get the token and userinfo
    async resolveCodeOAuth2() {
      const params = new URLSearchParams(window.location.search);
      const code = params.get("code");
      // const state = params.get('state');

      if (code) {
        const self = this;
        self.loadingAuth = true;

        // false perche le API sono nella route

        console.log("Code ottenuto da oauth2: ", code);

        axios
          .get(this.apiBaseUrl + "/config", {
            params: {
              code: code,
              oauth_to_be_use: "oauth2",
              redirect_uri: self.oauth.redirect_uri, //va comunicato il redirect-uri per cui si sta chiedendo il token
            },
            withCredentials: true,
          })
          .then((response) => {
            if (response?.data?.user?.access_token) {
              let access_token = response.data.user.access_token;
              let refresh_token = response.data.user.refresh_token;
              let user_info = response.data.user;

              this.setTokens({
                access_token: access_token,
                refresh_token: refresh_token,
                // expires_in: response.data.expires_in || 3600,
                user: user_info,
              });
            } else {
              console.error("Nessun access_token ricevuto: ", response.data);
            }

            console.log("Token ottenuto: ", response.data);
          })
          .catch((error) => {
            console.error("Errore durante l'ottenimento del token: ", error);
          })
          .finally(() => {
            // Rimuove i parametri dalla URL per evitare di ripetere l'operazione
            window.history.replaceState(
              {},
              document.title,
              window.location.pathname
            );

            self.loadingAuth = false;
          });
      }
    },

    /**
     * Imposta il token dopo il login
     */
    setTokens({ access_token, refresh_token, expires_in, user }) {
      const expiresAt = Date.now() + expires_in * 1000;

      this.accessToken = access_token;
      this.refreshToken = refresh_token;
      this.expiresAt = expiresAt;
      this.user = user || null;

      // Salva in sessionStorage (più sicuro di localStorage)
      sessionStorage.setItem("access_token", access_token);
      sessionStorage.setItem("refresh_token", refresh_token);
      sessionStorage.setItem("expires_at", expiresAt);
      sessionStorage.setItem("user", JSON.stringify(user || {}));
    },

    /**
     * Pulisce i dati di autenticazione
     */
    async logout() {
      let self = this;

      self.loadingAuth = true;

      let headers = {};
      if (this.accessToken) {
        headers["Authorization"] = `Bearer ${this.accessToken}`;
      }

      // logout lato server: prova POST /logout (federato), fallback a GET /config?logout=true
      try {
        await fetch(this.apiBaseUrl + "/config?logout=true", {
          method: "GET",
          headers,
          credentials: "include",
        });
      } catch (e) { }

      this.accessToken = null;
      this.refreshToken = null;
      this.expiresAt = null;
      this.user = null;

      sessionStorage.removeItem("access_token");
      sessionStorage.removeItem("refresh_token");
      sessionStorage.removeItem("expires_at");
      sessionStorage.removeItem("user");

      self.loadingAuth = true;

      //ricarica la pagina
      window.location.reload();
    },

    /**
     * Cambia profilo utente
     */
    async switchProfile(profile) {
      let self = this;

      self.loadingAuth = true;

      // let headers = {};
      // if (this.accessToken) {
      //   headers["Authorization"] = `Bearer ${this.accessToken}`;
      // }

      // Chiama l'API per cambiare profilo
      try {
        const response = await fetch(
          this.apiBaseUrl + `/config?change_profile=${profile.uid}`,
          {
            method: "GET",
            // headers,
            credentials: "include",
          }
        );

        if (response.ok) {
          const data = await response.json();



          // Aggiorna i dati utente se restituiti
          if (data.user) {
            this.user = data.user;
            sessionStorage.setItem("user", JSON.stringify(data.user));
          }
        }
      } catch (e) {
        console.error("Errore nel cambio profilo:", e);
        this.authError = "Errore nel cambio profilo";
      }

      // Ricarica la pagina per applicare il nuovo profilo
      window.location.reload();
    },

    // /**
    //  * Richiede un nuovo access token usando il refresh_token
    //  */
    // async refreshTokenIfNeeded() {
    //   if (!this.refreshToken) return;

    //   // Controlla se scade tra meno di 1 minuto
    //   const isExpiring = Date.now() > this.expiresAt - 60_000;
    //   if (!isExpiring) return;

    //   try {
    //     const resp = await fetch("https://tuo-provider-oauth/token", {
    //       method: "POST",
    //       headers: { "Content-Type": "application/x-www-form-urlencoded" },
    //       body: new URLSearchParams({
    //         grant_type: "refresh_token",
    //         refresh_token: this.refreshToken,
    //         client_id: import.meta.env.VITE_CLIENT_ID,
    //         // nessun client_secret nel browser
    //       }),
    //     });
    //     const data = await resp.json();
    //     if (data.access_token) {
    //       this.setTokens({
    //         access_token: data.access_token,
    //         refresh_token: data.refresh_token || this.refreshToken,
    //         expires_in: data.expires_in,
    //         user: this.user,
    //       });
    //     }
    //   } catch (err) {
    //     console.error("Errore nel refresh token:", err);
    //     this.logout();
    //   }
    // },

    /**
     * apiStore Esegue una chiamata API autenticata automaticamente
     * aggiorna i dati dello store relativi alla chiamata (apiState, apiResult)
     */
    async apiStore(url, options = {}) {
      // await this.refreshTokenIfNeeded();

      const self = this;
      self.apiState = "loading";

      //se url non assoluto lo completo
      if (!url.startsWith("http://") && !url.startsWith("https://")) {
        url = this.apiBaseUrl + url;
      }

      const headers = {
        ...(options.headers || {}),
      };

      // if (this.accessToken) {
      //   headers["Authorization"] = `Bearer ${this.accessToken}`;
      // }

      let result = fetch(url, { ...options, headers, credentials: "include" });
      try {
        const response = await result;
        if (!response.ok) {
          self.apiState = "error";
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        if (!data.ok) {
          self.apiState = "error";
          self.apiResult = data;
        } else {
          self.apiState = "loaded";
          self.apiResult = data;

          return data;
        }
      } catch (error) {
        console.error("Errore nella chiamata API autenticata:", error);
        self.apiState = "error";
        self.apiResult = { ok: false, message: error.message };
      }
    },

    async apiCall(url, options = {}) {
      //fa la chiamata API autenticata ma non cambia lo stato dello store
      //se url non assoluto lo completo
      if (!url.startsWith("http://") && !url.startsWith("https://")) {
        url = this.apiBaseUrl + url;
      }

      const headers = {
        ...(options.headers || {}),
      };

      // if (this.accessToken) {
      //   headers["Authorization"] = `Bearer ${this.accessToken}`;
      // }

      let result = fetch(url, { ...options, headers, credentials: "include" });
      try {
        const response = await result;
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = await response.json();
        return data;
      } catch (error) {
        return {
          ok: false,
          message: error.message,
        };
      }
    },
  },
});
